import { gql } from '@apollo/client'

export const SHORT_USER_FIELDS = gql`
	fragment ShortUserFields on User {
		firstName
		lastName
		email
		phoneNumber
		cnic
	}
`
export const USER_FIELDS = gql`
	fragment UserFields on User {
		_id
		firstName
		lastName
		phoneNumber
		email
		cnic
		UserType {
			_id
			userType
		}
	}
`

export const CONTACT_FIELDS = gql`
	fragment ContactFields on Contacts {
		name
		phoneNumber
	}
`

export const LOCATION_FIELDS = gql`
	fragment LocationFields on Location {
		_id
		formattedAddress
		additionalDetails
		type
		Region {
			_id
			ParentRegion {
				_id
			}
		}
	}
`

export const REGION_FIELDS = gql`
	fragment RegionFields on Region {
		_id
		name
		ParentRegion {
			_id
			name
		}
	}
`

export const CORPORATE_FIELDS = gql`
	fragment CorporateFields on Corporate {
		_id
		businessCode
		businessName
	}
`

export const BILTY_OPS_FIELDS = gql`
	${USER_FIELDS}
	${REGION_FIELDS}
	fragment BiltyOpsFields on BiltyOps {
		_id
		isBlocked
		User {
			...UserFields
		}
		Regions {
			...RegionFields
		}
	}
`

export const ORDER_LOCATION_FIELDS = gql`
	${CONTACT_FIELDS}
	${LOCATION_FIELDS}
	fragment OrderLocationFields on OrderLocation {
		_id
		locationType
		steps
		Location {
			...LocationFields
		}
		contacts {
			...ContactFields
		}
	}
`

export const SHIPMENT_INFO_FIELDS = gql`
	fragment ShipmentInfoFields on ShipmentInfo {
		freightCount
		freightType
		freightWeight
		estimatedWeight
		estimatedCount
	}
`

export const IMPORT_EXPORT_PREFERENCES_FIELDS = gql`
	fragment ImportExportPreferencesFields on SpecialRequest {
		movementType
		doIssuance
		numberFlatbeds
		otherRequests
		fastLane
		refNumber
	}
`

export const LONGHAUL_PREFERENCES_FIELDS = gql`
	fragment LongHaulPreferencesFields on LongHaulSpecialRequest {
		lotOrder
		numberVehicles
		otherRequests
		refNumber
	}
`

export const SUB_IMPORT_FIELDS = gql`
	${ORDER_LOCATION_FIELDS}
	fragment SubImportFields on ChildImport {
		_id
		loadingDT
		subOrderNumber
		status
		freeDays
		containerNumber
		dimension
		freightType
		freightWeight
		freightCount
		numberOfUnits
		OrderLocations {
			...OrderLocationFields
		}
		Invoice {
			invoiceDate
			invoiceNumber
		}
	}
`
export const SUB_EXPORT_FIELDS = gql`
	${ORDER_LOCATION_FIELDS}
	fragment SubExportFields on ChildExport {
		_id
		finalizedRate
		loadingDT
		subOrderNumber
		status
		containerNumber
		dimension
		freightType
		freightWeight
		OrderLocations {
			...OrderLocationFields
		}
		Invoice {
			invoiceDate
			invoiceNumber
		}
	}
`

export const SUB_LONGHAUL_FIELDS = gql`
	${ORDER_LOCATION_FIELDS}
	${SHIPMENT_INFO_FIELDS}
	fragment SubLongHaulFields on ChildLongHaul {
		_id
		loadingDT
		subOrderNumber
		status
		vehicleType
		vehicleSubType
		OrderLocations {
			...OrderLocationFields
		}
		shipmentInfo {
			...ShipmentInfoFields
		}
		Invoice {
			invoiceDate
			invoiceNumber
		}
	}
`

export const VEHICLE_FIELDS = gql`
	fragment VehicleFields on Vehicle {
		registrationNumber
	}
`

export const DRIVER_FIELDS = gql`
	fragment DriverFields on Driver {
		_id
		name
		phoneNumber
		cnic
		cnicDocument
	}
`
export const BROKER_FIELDS = gql`
	${SHORT_USER_FIELDS}
	fragment BrokerFields on Broker {
		CompanyName
		User {
			...ShortUserFields
		}
	}
`

export const BILTY_FIELDS = gql`
	fragment BiltyFields on Bilty {
		_id
		createdAt
		biltyNumber
		isCancelled
		isInformationComplete
		kantaDocument
		lcNumber
		loloDocument
		seal
		amanat
		amanatUpload
		documentNumber
		biltyDocument
		biltyCompletedBy
		biltyCreatedBy
		biltyStatus
		croDocument
		eirDocument
		gatePassDocument
		gateIn
		gateOut
		halfDoneBiltyDocument
		initialEirDocument
		initialKantaCharges
		initialKantaDocument
		initialKantaWeight
		kantaCharges
		kantaWeight
		loloCharges
		offLoadingCharges
		offLoadingUpload
		placementCharges
		remarks
		repairingCharges
		rotationalCharges
		rotationalReceipt
		biltyCreatedAt
		biltyCompletedAt
		biltySource
		numberOfBales
		biltyType
		biltyCancelledAt
		biltyCancelledBy
		biltyCancelReason
	}
`

export const DRIVER_STATUS_HISTORIES = gql`
	fragment DriverStatusHistoriesFields on DriverStatusHistory {
		_id
		status
		timestamp
	}
`

export const DRIVER_STATUS_JOURNEYS = gql`
	fragment DriverStatusJourneysFields on DriverStatusJourney {
		_id
		type
		status
		timestamp
		formattedAddress
	}
`
export const JOURNEY_FIELDS = gql`
	${ORDER_LOCATION_FIELDS}
	${DRIVER_STATUS_HISTORIES}
	${DRIVER_STATUS_JOURNEYS}
	fragment JourneyFields on Journey {
		_id
		next
		steps
		isCompleted
		toOrderLocation {
			...OrderLocationFields
		}
		fromOrderLocation {
			...OrderLocationFields
		}
		DriverStatusHistories {
			...DriverStatusHistoriesFields
			DriverStatusJourneys {
				...DriverStatusJourneysFields
			}
		}
	}
`

export const JOURNEY_SUBSCRIPTION_FIELD = gql`
	${ORDER_LOCATION_FIELDS}
	${DRIVER_STATUS_HISTORIES}
	${DRIVER_STATUS_JOURNEYS}
	fragment JourneySubscriptionFields on Journey {
		_id
		next
		steps
		isCompleted
		toOrderLocation {
			...OrderLocationFields
		}
		fromOrderLocation {
			...OrderLocationFields
		}
		DriverStatusHistories {
			...DriverStatusHistoriesFields
			DriverStatusJourneys {
				...DriverStatusJourneysFields
			}
		}
	}
`

export const TRACKER_FIELDS = gql`
	fragment TrackerFields on Tracker {
		_id
		name
		provider
		isConnected
		status
	}
`

export const SUPPLIER_FIELDS = gql`
	${SHORT_USER_FIELDS}
	fragment SupplierFields on Supplier {
		_id
		User {
			...ShortUserFields
		}
	}
`

export const JOB_FIELDS = gql`
	${SHORT_USER_FIELDS}
	${VEHICLE_FIELDS}
	${DRIVER_FIELDS}
	${BILTY_FIELDS}
	${BROKER_FIELDS}
	${TRACKER_FIELDS}
	${SUPPLIER_FIELDS}
	${JOURNEY_FIELDS}
	fragment JobFields on Job {
		_id
		jobNumber
		createdAt
		status
		cost
		driverMatchedAt
		driverAssignedAt
		trackerComment
		Tracker {
			...TrackerFields
		}
		Vehicle {
			...VehicleFields
		}
		Driver {
			...DriverFields
		}
		Broker {
			...BrokerFields
		}
		MatchedBy {
			...ShortUserFields
		}
		bilty(options: $biltyOptions2) {
			...BiltyFields
		}
		Supplier {
			...SupplierFields
		}
		Journeys {
			...JourneyFields
		}
	}
`

export const JOBS_SUBSCRIPTION_FIELD = gql`
	${SHORT_USER_FIELDS}
	${VEHICLE_FIELDS}
	${DRIVER_FIELDS}
	${BILTY_FIELDS}
	${BROKER_FIELDS}
	${TRACKER_FIELDS}
	${SUPPLIER_FIELDS}
	${JOURNEY_SUBSCRIPTION_FIELD}
	fragment JobSubscriptionFields on Job {
		_id
		jobNumber
		createdAt
		status
		cost
		driverMatchedAt
		driverAssignedAt
		trackerComment
		Tracker {
			...TrackerFields
		}
		Vehicle {
			...VehicleFields
		}
		Driver {
			...DriverFields
		}
		Broker {
			...BrokerFields
		}
		MatchedBy {
			...ShortUserFields
		}
		bilty {
			...BiltyFields
		}
		Supplier {
			...SupplierFields
		}
		Journeys {
			...JourneySubscriptionFields
		}
	}
`

export const MOVEMENT_FIELDS = gql`
	${JOB_FIELDS}
	${SUB_IMPORT_FIELDS}
	${SUB_EXPORT_FIELDS}
	${SUB_LONGHAUL_FIELDS}
	fragment MovementFields on Movement {
		_id
		ChildOrder {
			_id
			SubImport {
				...SubImportFields
			}
			SubExport {
				...SubExportFields
			}
			SubLongHaul {
				...SubLongHaulFields
			}
		}
		movementType
		subMovementType
		count
		totalCount
		movedUnits
		partialMatch
		status
		Job {
			...JobFields
		}
	}
`

export const MOVEMENT_SUBSCRIPTION_FIELDS = gql`
	${JOBS_SUBSCRIPTION_FIELD}
	${SUB_IMPORT_FIELDS}
	${SUB_EXPORT_FIELDS}
	${SUB_LONGHAUL_FIELDS}
	fragment MovementSubscriptionFields on Movement {
		ChildOrder {
			_id
			SubImport {
				...SubImportFields
			}
			SubExport {
				...SubExportFields
			}
			SubLongHaul {
				...SubLongHaulFields
			}
		}
		movementType
		subMovementType
		status
		count
		totalCount
		movedUnits
		partialMatch
		Job {
			...JobSubscriptionFields
		}
	}
`

export const PARENT_IMPORT_FIELDS = gql`
	${CONTACT_FIELDS}
	${IMPORT_EXPORT_PREFERENCES_FIELDS}
	fragment ParentImportFields on ParentImport {
		_id
		orderNumber
		status
		document
		documentNumber
		shippingLine
		clearingAgents {
			...ContactFields
		}
		preferences {
			...ImportExportPreferencesFields
		}
	}
`

export const PARENT_EXPORT_FIELDS = gql`
	${CONTACT_FIELDS}
	${IMPORT_EXPORT_PREFERENCES_FIELDS}
	fragment ParentExportFields on ParentExport {
		_id
		document
		documentNumber
		shippingLine
		orderNumber
		status
		vesselCutoffDT
		clearingAgents {
			...ContactFields
		}
		preferences {
			...ImportExportPreferencesFields
		}
	}
`

export const PARENT_LONGHAUL_FIELDS = gql`
	${SUB_LONGHAUL_FIELDS}
	${LONGHAUL_PREFERENCES_FIELDS}
	fragment ParentLongHaulFields on ParentLongHaul {
		_id
		orderNumber
		status
		expectedMovementDeadline
		preferences {
			...LongHaulPreferencesFields
		}
	}
`

export const ORDER_FIELDS = gql`
	${PARENT_EXPORT_FIELDS}
	${PARENT_IMPORT_FIELDS}
	${PARENT_LONGHAUL_FIELDS}
	${CORPORATE_FIELDS}
	${MOVEMENT_FIELDS}
	fragment OrderFields on Order {
		_id
		type
		businessCode
		clientEmails
		createdAt
		Corporate {
			...CorporateFields
		}
		ParentOrder {
			ParentImport {
				...ParentImportFields
				SubImports {
					_id
				}
			}
			ParentExport {
				...ParentExportFields
				SubExports {
					_id
				}
			}
			ParentLongHaul {
				...ParentLongHaulFields
				SubLongHauls {
					_id
				}
			}
			Movements(where: $movementsWhere2) {
				...MovementFields
			}
		}
	}
`
export const ORDER_SUBSCRIPTION_FIELDS = gql`
	${CORPORATE_FIELDS}
	${PARENT_IMPORT_FIELDS}
	${PARENT_EXPORT_FIELDS}
	${PARENT_LONGHAUL_FIELDS}
	${MOVEMENT_SUBSCRIPTION_FIELDS}
	fragment OrderSubscriptionFields on Order {
		_id
		type
		businessCode
		clientEmails
		createdAt
		Corporate {
			...CorporateFields
		}
		ParentOrder {
			ParentImport {
				...ParentImportFields
				SubImports {
					_id
				}
			}
			ParentExport {
				...ParentExportFields
				SubExports {
					_id
				}
			}
			ParentLongHaul {
				...ParentLongHaulFields
				SubLongHauls {
					_id
				}
			}
			Movements {
				...MovementSubscriptionFields
			}
		}
	}
`
